import { RecordIcon } from "@hugeicons-pro/core-solid-rounded";
import config from "config/config";
import { PromoFeatureName, PromoContent, PromoSize } from "./types";

const RELEASE_DATE = new Date("2026-01-30");
const FEATURE_FLAG_EXPIRY_DAYS = 32;
const USER_CREATION_CUTOFF_DAYS = 7;

export const FEATURE_FLAG_EXPIRY_DATE = new Date(
  RELEASE_DATE.getTime() + FEATURE_FLAG_EXPIRY_DAYS * 24 * 60 * 60 * 1000
);
export const USER_CREATION_CUTOFF_DATE = new Date(
  RELEASE_DATE.getTime() + USER_CREATION_CUTOFF_DAYS * 24 * 60 * 60 * 1000
);

const CHAT_INBOX_RELEASE_DATE_FALLBACK = "2026-08-07";
const CHAT_INBOX_EXPIRY_DAYS = 60;

const parseReleaseDate = (value?: string) => {
  const parsed = new Date(value || CHAT_INBOX_RELEASE_DATE_FALLBACK);

  return Number.isNaN(parsed.getTime())
    ? new Date(CHAT_INBOX_RELEASE_DATE_FALLBACK)
    : parsed;
};

export const CHAT_INBOX_RELEASE_DATE = parseReleaseDate(
  config.chatInboxPromoReleaseDate
);
export const CHAT_INBOX_EXPIRY_DATE = new Date(
  CHAT_INBOX_RELEASE_DATE.getTime() +
    CHAT_INBOX_EXPIRY_DAYS * 24 * 60 * 60 * 1000
);

const FULL_COMBINED_INCOME_PROMO_CONTENT: PromoContent = {
  imageSrc: "/assets/promo/combined-income.png",
  icons: [
    {
      src: "/assets/atomic_logo.svg",
      alt: "Atomic logo",
      width: 76,
      height: 20,
      classNames: "w-[76px] h-[20px]"
    },
    {
      src: "/assets/pinwheel_logo.svg",
      alt: "Pinwheel logo",
      width: 76,
      height: 20,
      classNames: "w-[76px] h-[20px]"
    },
    {
      src: "/assets/inscribe_logo.svg",
      alt: "Inscribe logo",
      width: 76,
      height: 22,
      classNames: "w-[64px] h-[22px]"
    },
    {
      src: "/assets/ocrolus_logo.svg",
      alt: "Ocrolus logo",
      width: 74,
      height: 22,
      classNames: "w-[74px] h-[22px]"
    }
  ],
  title: "Introducing Income Verification 2.0",
  subtitle:
    "A redesigned income verification experience that supports complex income scenarios. Now live for all of your screening templates.",
  description: "",
  bulletPoints: [
    "Verify multiple income sources within a single application",
    "Support bank, document, or payroll-based verification for each source",
    "Review income at the source level with clearer statuses and details",
    "Reduce manual follow-up with more accurate verification"
  ],
  actionButtonTitle: "Watch demo",
  actionButtonLink:
    "https://intercom.help/boomhelpcenter/en/articles/13517645-income-verification-2-0",
  onCloseClassNames: "w-[125px]"
};

const FULL_CHAT_MOVED_TO_INBOX_PROMO_CONTENT: PromoContent = {
  imageSrc: "/assets/promo/chat-moved-to-inbox.png",
  title: "Chat has a new home: Inbox",
  subtitle:
    "Everything you did in Chat works exactly the same — it just moved. Inbox brings all your communications together so you're not checking two places. We've migrated all of your Chat history so that nothing was lost in the migration.",
  bulletPoints: [
    "Texts are sent automatically when you send a Chat message",
    "Applicants see no change on their side",
    "Every conversation (Chat, SMS, and Email) is now in one place",
    "Questions? Contact us and we'll walk you through what else Inbox can do"
  ],
  bulletIcon: RecordIcon,
  closeButtonTitle: "Close",
  actionButtonTitle: "Show me Inbox",
  actionButtonRoute: "/inbox",
  onCloseClassNames: "w-auto",
  actionButtonClassNames: "w-auto"
};

export const PROMO_FEATURES: Record<
  PromoFeatureName,
  Record<PromoSize, PromoContent>
> = {
  [PromoFeatureName.CombinedIncome]: {
    [PromoSize.XS]: {
      ...FULL_COMBINED_INCOME_PROMO_CONTENT,
      imageSrc: "/assets/promo/combined-income-xs.png",
      icons: [],
      description: "",
      bulletPoints: [],
      onCloseClassNames: ""
    },
    [PromoSize.SM]: {
      ...FULL_COMBINED_INCOME_PROMO_CONTENT,
      description: ""
    },
    [PromoSize.BASE]: FULL_COMBINED_INCOME_PROMO_CONTENT
  },
  [PromoFeatureName.ChatMovedToInbox]: {
    [PromoSize.XS]: {
      ...FULL_CHAT_MOVED_TO_INBOX_PROMO_CONTENT,
      imageSrc: "/assets/promo/chat-moved-to-inbox-xs.png",
      subtitle:
        "Everything you did in Chat works exactly the same — it just moved. Inbox brings all your applicant communication together, so you're not checking two places.",
      bulletPoints: [],
      closeButtonTitle: "Dismiss",
      onCloseClassNames: "",
      actionButtonClassNames: ""
    },
    [PromoSize.SM]: FULL_CHAT_MOVED_TO_INBOX_PROMO_CONTENT,
    [PromoSize.BASE]: FULL_CHAT_MOVED_TO_INBOX_PROMO_CONTENT
  }
};
